import { APIClient } from "./axiosClient";

export interface TransactionListPayload {
  startDateInMillis?: string;
  endDateInMillis?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  pageNumber: number;
  pageSize: number;
  accrualStatus?: string;
  merchantTransactionId?: string;
  transactionAmount?: string;
  programMemberId?: string;
  id?: string;
  programCode?: string;
  merchantCode?: string;
  merchantId?: number;
}

export class TransactionApi {
  static getTransactionsFromDB(payload: TransactionListPayload) {
    return APIClient("/transaction/getTransactionsFromDB", payload, { requestType: 'post' });
  }

  static getTransactionsDashboardFromDB(payload: TransactionListPayload) {
    return APIClient("/transaction/getTransactionsDashboardFromDB", payload, { requestType: 'post' });
  }

  static getAccountingEntries(payload = {
    pageNumber: 0,
    pageSize: 5,
    entryType: null,
    sortOrder: "desc",
    sortBy: "createdDate",
    invoiceId: null,
    transferTransactionId: null,
    amount: null,
    transactionType: "earn",
    programCode: null,
    transactionId: null,
    merchantTransactionId: null,
    accountType: null,
    accountName: null,
    startDate: null,
    endDate: null
  }) {
    return APIClient("/accounting-entry/getAccountingEntries", payload, { requestType: 'post' });
  }

  static updateTransactionStatus(transactionId: string, status: number) {
    return APIClient(`/transaction/updateTransactionStatus?transactionId=${transactionId}&status=${status}`);
  }

  static getGeneralStats(payload: { clientId: number } | null) {
    return APIClient("/transaction/getGeneralStats", payload, { requestType: 'post' });
  }
} 